/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { JobCompleteDetails } from "../types/JobCompleteDetails";
export const Request = JobCompleteDetails.optional();
